import { useState, useEffect } from "react";
import ".././styles/NewsAnnouncements.css";

import NewsCard from ".././components/NewsCard";

const RSS2JSON_API_KEY = 'unrobsdshc0uiipzo2eqw63dccehc2xnxrdb5oax';

function NewsAnnouncements() {    
    const [feed, setFeed] = useState([]);
    const [currentSeasonFeed, setCurrentSeasonFeed] = useState([]);
    const [pastSeasonFeed, setPastSeasonFeed] = useState([]);

    // Function to get the current season based on the month
    const getSeason = (dateString) => {
        const date = new Date(dateString);
        const month = date.getMonth(); // 0 for January, 11 for December

        if (month >= 2 && month <= 4) { // March, April, May
            return "spring";
        } else if (month >= 5 && month <= 7) { // June, July, August
            return "summer";
        } else if (month >= 8 && month <= 10) { // September, October, November
            return "fall";
        } else { // December, January, February
            return "winter";
        }
    };

    useEffect(() => {
        const fetchFeed = async () => {
            try {
                const rssFeedUrl = 'https%3A%2F%2Fthenewpccm.substack.com%2Ffeed';
                const apiUrl = `https://api.rss2json.com/v1/api.json?rss_url=${rssFeedUrl}&api_key=${RSS2JSON_API_KEY}`;

                const res = await fetch(apiUrl);
                const data = await res.json();
                const allItems = data.items || [];
                setFeed(allItems);

                // Get the current season for the user's current date
                const currentMonth = new Date().getMonth();
                const currentYear = new Date().getFullYear();
                const currentDate = new Date().getDate();
                const currentSeason = getSeason(new Date(currentYear, currentMonth, currentDate).toISOString());


                const filteredCurrentSeason = allItems.filter(item => {
                    const itemDate = new Date(item.pubDate);
                    return getSeason(item.pubDate) === currentSeason && itemDate.getFullYear() === currentYear;
                });

                const filteredPastSeason = allItems.filter(item => {
                    const itemDate = new Date(item.pubDate);
                    // An item is "past season" if it's not the current season OR it's the current season but from a past year
                    return !(getSeason(item.pubDate) === currentSeason && itemDate.getFullYear() === currentYear);
                });
                
                setCurrentSeasonFeed(filteredCurrentSeason);
                setPastSeasonFeed(filteredPastSeason);

            } catch (error) {
                console.error("RSS fetch failed:", error);
            }
        };

        fetchFeed();
    }, []); // Empty dependency array means this effect runs once after the initial render

    return (
        <>
            <div className="container">
                <div className="news-banner-container" id="banner">
                    <div className="news-banner">
                        <h1>News and Announcements</h1>
                    </div>
                </div>
            </div>
            <div id="pccm-newsletter">
                <h2 className="section-title" id="news">This Season's Issue</h2>
                <div className="rss-feed">
                    {currentSeasonFeed.length > 0 ? (
                        currentSeasonFeed.map((item, index) => (
                            <div key={index} className="rss-item">
                                <NewsCard
                                    image={item.thumbnail}
                                    title={item.title}
                                    date={item.pubDate}
                                    description={item.description}
                                    link={item.link}
                                />
                            </div>
                        ))
                    ) : (
                        <p className="na">No news for this season yet.</p>
                    )}
                </div>
            </div>
            <div id="old-newsletter">
                <h2 className="section-title" id="news">Past Issues</h2>
                <div className="rss-feed">
                    {pastSeasonFeed.length > 0 ? (
                        pastSeasonFeed.map((item, index) => (
                            <div key={index} className="rss-item">
                                <NewsCard
                                    image={item.thumbnail}
                                    title={item.title}
                                    date={item.pubDate}
                                    description={item.description}
                                    link={item.link}
                                />
                            </div>
                        ))
                    ) : (
                        <p className="na">No past issues available.</p>
                    )}
                </div>
            </div>
        </>
    );
}

export default NewsAnnouncements;